import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AdminService, HandleErrorsService } from '../app-services';

export const adminDetailsResolver: ResolveFn<unknown> = route => {
  const adminService = inject(AdminService);
  const handleErrors = inject(HandleErrorsService);

  return adminService.getAdmin(+route.params['id']).pipe(
    map(res => ({
      ...res.data,
      allowedPPF: Number(res.data.allowedPPF).toFixed(2),
      allowedWindows: Number(res.data.allowedWindows).toFixed(2),
    })),
    catchError(err => {
      handleErrors.handleErrors(err);

      return throwError(() => err);
    }),
  );
};
